import configureStore, { history } from 'common/configure-store';
import reducer, { ClientReducerState } from './reducers';

export { history };

const clientStore = configureStore({} as ClientReducerState, reducer, { id: 'clientStore' });

export default clientStore;
